import { PasswordValidation, Validity } from './types';
import { configuration } from './configuration';

/**
 * Validates strength/complexity of new passwords
 *
 * @method validatePassword
 * @memberof Password
 * @param  {string} password - New password
 * @param  {string} username? - User's username
 * @param  {string} firstName? - User's first name
 * @param  {string} lastName? - User's last name
 * @returns {PasswordValidation} - Validity of passwords and any requirements not met
 */

export const validatePassword = (
  password: string,
  username?: string,
  firstName?: string,
  lastName?: string
): PasswordValidation => {
  const { blockedWords, minLength, uppercaseRegex, lowercaseRegex, numberRegex, symbolRegex } = configuration;

  const requirements = {
    username: Validity.UNCHECKED,
    firstName: Validity.UNCHECKED,
    lastName: Validity.INVALID,
    blockedWords: Validity.UNCHECKED,
    symbol: Validity.UNCHECKED,
    uppercase: Validity.UNCHECKED,
    lowercase: Validity.UNCHECKED,
    number: Validity.UNCHECKED,
    length: Validity.UNCHECKED,
  };

  requirements.blockedWords = Validity.VALID;

  blockedWords.forEach((word) => {
    password.toLowerCase().includes(word.toLowerCase()) && (requirements.blockedWords = Validity.INVALID);
  });

  requirements.username =
    username && password.toLowerCase().includes(username.toLowerCase()) ? Validity.INVALID : Validity.VALID;

  requirements.firstName =
    firstName && password.toLowerCase().includes(firstName.toLowerCase()) ? Validity.INVALID : Validity.VALID;

  requirements.lastName =
    lastName && password.toLowerCase().includes(lastName.toLowerCase()) ? Validity.INVALID : Validity.VALID;

  requirements.length = password.length < minLength ? Validity.INVALID : Validity.VALID;

  requirements.uppercase = Validity.INVALID;
  requirements.lowercase = Validity.INVALID;
  requirements.number = Validity.INVALID;
  requirements.symbol = Validity.INVALID;

  const charArray = Array.from(password);

  charArray.forEach((char) => {
    uppercaseRegex.test(char) && (requirements.uppercase = Validity.VALID);
    lowercaseRegex.test(char) && (requirements.lowercase = Validity.VALID);
    numberRegex.test(char) && (requirements.number = Validity.VALID);
    symbolRegex.test(char) && (requirements.symbol = Validity.VALID);
  });

  return {
    valid: Object.values(requirements).includes(Validity.INVALID) ? Validity.INVALID : Validity.VALID,
    requirements,
  };
};
